(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
function stlSetupProducts(){
  document.querySelectorAll('[data-section-type="product"]').forEach(function(root){
    if(root.dataset.stlReady)return;
    const bar=root.querySelector('.stl-sticky-buy');
    const json=document.getElementById('ProductJson-'+root.dataset.sectionId);
    if(!bar||!json)return;
    root.dataset.stlReady='true';
    const product=JSON.parse(json.textContent);
    const selectors=Array.from(root.querySelectorAll('.single-option-selector'));
    const button=bar.querySelector('button');
    const state=root.querySelector('.stl-availability');
    function update(){
      const values=selectors.map(s=>s.value);
      const variant=product.variants.find(v=>values.every((value,i)=>v.options[i]===value));
      selectors.forEach(function(select,i){
        const isSize=product.options[i].toLowerCase()==='size';
        Array.from(select.options).forEach(function(option){
          const possible=product.variants.filter(v=>v.options[i]===option.value&&(!isSize||values.every((value,j)=>j===i||v.options[j]===value)));
          const available=possible.some(v=>v.available);
          option.textContent=option.value+(available?'':' — '+(possible.length?bar.dataset.soldOut:bar.dataset.unavailable));
        });
      });
      button.disabled=!variant||!variant.available;
      button.textContent=!variant?bar.dataset.unavailable:variant.available?bar.dataset.add:bar.dataset.soldOut;
      state.textContent=!variant?bar.dataset.unavailable:variant.available?'':bar.dataset.soldOut;
      bar.querySelector('.stl-sticky-variant').textContent=variant?variant.title:'';
    }
    root.addEventListener('change',update);
    root.querySelectorAll('.stl-size-help').forEach(link=>link.addEventListener('click',function(event){
      const guide=root.querySelector('#stl-size-guide');
      if(guide){event.preventDefault();guide.open=true;guide.scrollIntoView({behavior:'smooth',block:'center'});guide.querySelector('summary')?.focus();}
    }));
    update();
  });
}
document.addEventListener('DOMContentLoaded',stlSetupProducts);
document.addEventListener('shopify:section:load',stlSetupProducts);
stlSetupProducts();

  } catch(e) { console.error(e); }
})();
})();
